import { render, staticRenderFns } from "./TableWidgetType.vue?vue&type=template&id=8c055bae&"
import script from "./TableWidgetType.vue?vue&type=script&lang=js&"
export * from "./TableWidgetType.vue?vue&type=script&lang=js&"
import style0 from "./TableWidgetType.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports